import { EnvironmentProviders, Provider } from '@angular/core';
import { DialogEventState } from '@app/main/leak-detection/dialogs/dialog-event/services/dialog-event-state.service';
import { DialogEventHistory } from '@app/main/leak-detection/dialogs/dialog-event/services/dialog-event-history.service';
import { DialogEventTabsService } from '@app/main/leak-detection/dialogs/dialog-event/services/dialog-event-tabs.service';

export function dialogEventProvider(): (EnvironmentProviders | Provider)[] {
  return [DialogEventState, DialogEventHistory, DialogEventTabsService];
}
